import { Component, OnInit, Inject } from '@angular/core';
import { BaseDialog } from '../../../base-dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AddressResponseItem } from '../../../services/api/profile-address.service';

@Component({
  selector: 'mandae-address-default-dialog',
  templateUrl: './address-default-dialog.component.html',
  styleUrls: ['./address-default-dialog.component.scss']
})
export class AddressDefaultDialogComponent extends BaseDialog<AddressDefaultDialogComponent> implements OnInit {

  public type: string;
  public address: AddressResponseItem;

  constructor(@Inject(MAT_DIALOG_DATA) data, dialogRef: MatDialogRef<AddressDefaultDialogComponent>) {
    super(dialogRef);

    this.type = data.type;
    this.address = data.address;
  }

  ngOnInit() {
  }

}
